export enum DocumentTypeEnum {

    CPF = 1,

    PASSPORT = 2,

    CNH = 3
}
